import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { supportConnectionSelector } from '../selectors/authSelectors';
import { getSupportConnectionRequest, connectToSupportVPNRequest } from '../actions/authActions';
import SupportConnectionDialog from '../components/SupportConnectionDialog/SupportConnectionDialog';

const mapStateToProps = createStructuredSelector({ supportConnection: supportConnectionSelector });
const mapDispatchToProps = {
    getSupportConnectionRequest,
    connectToSupportVPNRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(SupportConnectionDialog);
